import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Typography, Grid, Button, Paper, Container, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Icon } from '@iconify/react';
import emailOutline from '@iconify/icons-eva/email-outline';
import phoneOutline from '@iconify/icons-eva/phone-outline';
import homeOutline from '@iconify/icons-eva/home-outline';
import { ContactForm } from '../components/_dashboard/user';
import { termsData } from '../DATA/DataText';

const useStyles = makeStyles((theme) => ({
  backgroundFix: {
    position: 'relative',
    height: '200px',
    marginTop: 120,
    width: '100%',
    backgroundColor: '#F78181',
    backgroundAttachment: 'fixed',
    zIndex: 2
  },
  centerTitleContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  centerTitle: {
    width: 400,
    height: 150,
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    '& h1': {
      fontSize: '37px',
      fontWeight: 500,
      color: 'white'
    },
    '& h3': {
      fontSize: '20px',
      fontWeight: 500,
      color: 'white',
      marginTop: 15
    }
  },
  gridContainer: {
    // backgroundColor: 'pink',
    display: 'flex',
    alignItems: 'center',
    marginBottom: 50,
    marginTop: 100
  },
  text: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '2rem',
    color: 'blak',
    marginTop: 10,
    fontFamily: 'Open Sans, sans-serif'
  },
  title: {
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '19px',
    fontWeight: 'bold',
    color: '#F78181',
    marginBottom: 10
  },
  list: {
    paddingLeft: 35,
    '& li': {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '2rem',
      color: 'blak',
      marginTop: 10,
      fontFamily: 'Open Sans, sans-serif'
    }
  }
}));

const Terms = () => {
  const classes = useStyles();
  return (
    <div>
      <Grid container xs={12} className={classes.backgroundFix}>
        <Box className={classes.centerTitleContainer}>
          <Box className={classes.centerTitle}>
            <h1>Terms And Conditions</h1>
          </Box>
        </Box>
      </Grid>
      <Container maxWidth="md" style={{ marginBottom: 200 }}>
        <Grid container xs={12} className={classes.gridContainer}>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>Welcome to SmileLand!</Typography>
            <Typography className={classes.text}>
              These terms and conditions outline the rules and regulations for the use of Company
              Name's Website, located at Website.com.
            </Typography>
            <Typography className={classes.text}>
              By accessing this website we assume you accept these terms and conditions. Do not
              continue to use Website Name if you do not agree to take all of the terms and
              conditions stated on this page.
            </Typography>
            <Typography className={classes.text}>
              The following terminology applies to these Terms and Conditions, Privacy Statement and
              Disclaimer Notice and all Agreements: and refers to you, the person log on this
              website and compliant to the Company's terms and conditions. refers to our Company.
              refers to both the Client and ourselves. All terms refer to the offer, acceptance and
              consideration of payment necessary to undertake the process of our assistance to the
              Client in the most appropriate manner for the express.
            </Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>Cookies</Typography>
            <Typography className={classes.text}>
              We employ the use of cookies. By accessing Website Name, you agreed to use cookies in
              agreement with the Company Name's Privacy Policy.
            </Typography>
            <Typography className={classes.text}>
              Most interactive websites use cookies to let us retrieve the user's details for each
              visit. Cookies are used by our website to enable the functionality of certain areas to
              make it easier for people visiting our website. Some of our affiliate/advertising
              partners may also use cookies.
            </Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>License</Typography>
            <Typography className={classes.text}>
              Unless otherwise stated, Company Name and/or its licensors own the intellectual
              property rights for all material on SmileLand. All intellectual property rights are
              reserved. You may access this from SmileLand for your own personal use subjected to
              restrictions set in these terms and conditions.
            </Typography>
            <Typography className={classes.text}>You must not:</Typography>
            <ul className={classes.list}>
              <li>Republish material from SmileLand</li>
              <li>Sell, rent or sub-license material from SmileLand</li>
              <li>Reproduce, duplicate or copy material from SmileLand</li>
              <li>Redistribute content from SmileLand</li>
            </ul>
          </Box>
        </Grid>
      </Container>
    </div>
  );
};

export default Terms;
